<!-- eslint-disable vue/multi-word-component-names -->
<template>
	
	<div ref="table"></div>

</template>





<script>
// Look at: https://tabulator.info/docs/6.3/vue


export default {
	

	
	props: {
		
		/**
		 * The field's `id` value. Required.  
		 * Should be unique among all elements currently rendered on the page.
		 */
		id: {
			type: String,
			required: true
		},

		/**
		 * The field's `name` value. 
		 * If not defined, `id` is used.
		 */
		name: {
			type: String
		},

		/**
		 * Additional CSS class(s) to apply.  
		 * Does NOT overwrite default classes.
		 */
		cssClass: {
			type: String
		},


		/**
		 * The data to display in the table
		 */
		data: {
			type: [ Array, null ],
			default: () => []
		},


		/**
		 * Definitions and configuration of all columns in the table.
		 * See https://tabulator.info/docs/6.3/columns - we're using these directly.
		 */
		columns: {
			type: [ Array, null],
			default: () => []
		},



		/**
		 * Tabulator setup/config options.
		 * See https://tabulator.info/docs/6.3/options - we're using these directly.
		 */
		options: {
			type: [ Object, null],
			default: null
		}
	},





	data()
	{
		return {
			tabulator: null, //variable to hold your table
			tableData: []	// Load this from the `data` prop. It's a separate data structure because we need to mutate it via a watcher.
		};
	},




	mounted()
	{
		this.init();
	},





	computed: {

	},




	watch: {
		// data: function(to, from)
		// {
		// 	console.log("watch[tableData][" + this.id + "]: tableData=", this.tableData, "to=", to, "from=", from);

		// 	if (to == null || to == undefined)
		// 	{
		// 		console.log("   watch[modelValue][" + this.id + "]: NO VALUE passed in");
		// 		return;
		// 	}

		// 	this.tableData.splice(0, this.tableData.length);

		// 	for (var i = 0; i < to.length; i++)
		// 	{
		// 		//console.log("to[" + i + "]=", to[i]);
				
		// 		this.tableData.push(to[i]);
		// 	}
		// },

		data: {
			handler: function(to, from)
			{
				console.log("watch[tableData][" + this.id + "]: tableData=", this.tableData, "to=", to, "from=", from);

				if (to == null || to == undefined)
				{
					console.log("   watch[modelValue][" + this.id + "]: NO VALUE passed in");
					return;
				}


				//-- V1
				// this.tableData.splice(0, this.tableData.length);

				// let data = [];
				// for (var i = 0; i < to.length; i++)
				// {
				// 	//console.log("to[" + i + "]=", to[i]);
					
				// 	this.tableData.push(to[i]);
				// 	//data.push(to[i]);
				// }
				
				//-- V2
				this.tableData = to;
				this.tabulator.replaceData(to);
			},
			deep: true
		}
	},



	methods: {
		init()
		{
			this.setupTable();
		},

		setupTable()
		{
			console.log("data-table.setupOptions(): this.options=", this.options);

			//instantiate Tabulator when element is mounted
			let setupOptions = this.options || {};
			//let setupOptions = {};
			
			//-- Overrides
			//setupOptions.layout = "responsiveLayout";
			setupOptions.reactiveData = true; //enable data reactivity
			setupOptions.data = this.tableData; //link data to table
			setupOptions.columns = this.columns;	// Assumes the caller will not need update the definition after passing it in.

			console.log("data-table.setupOptions(): setupTable=", setupOptions);

			this.tabulator = new Tabulator(this.$refs.table, setupOptions);


			// this.tabulator = new Tabulator(this.$refs.table, {
			// 	//layout:"responsiveLayout",
			// 	reactiveData:true, //enable data reactivity

			// 	data: this.tableData, //link data to table
			// 	columns: this.tableColumns,
			// });
		},

	}
}
</script>





<style scoped lang="scss">
	@use "/assets/sass/_global.scss" as *;

	

	.c-data-table
	{
		
	}

</style>